import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_FeildActivity_Interface, FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';


@Component({
  selector: 'app-FeildActivityList',
  templateUrl: './FeildActivityList.component.html',
  styleUrls: ['./FeildActivityList.component.scss']
})
export class FeildActivityListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private FeildActivity_Service:FeildActivityService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_FeildActivity:Array<FeildActivity_Interface>=[]
  Data_Seleted_Delete:FeildActivity_Interface=Empty_FeildActivity_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,17).subscribe(
      data=>{
        this.ReadData_FeildActivity()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_FeildActivity(){
    this.Procssing=true
    this.FeildActivity_Service.GetAll(this.Token).subscribe(
      data=>{
        this.DataList_FeildActivity=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:FeildActivity_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.FeildActivity_Service.DeleteFeildActivity(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully")
        this.ReadData_FeildActivity()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
